import styled from "styled-components"
import { FaTimes } from "react-icons/fa"
import { Link } from "gatsby"

export const SidebarContainer = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: #e8ecf1;
  display: grid;
  align-items: center;
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;
  opacity: ${props => (props.isOpen ? "100% " : "")};
  top: ${props => (props.isOpen ? "0" : "-100%")};
`

export const CloseIcon = styled(FaTimes)`
  font-size: 1.8rem;
  color: #333;
`

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  font-size: 2rem;
  cursor: pointer;
  outline: none;
`

export const SidebarWrapper = styled.div`
  color: #fff;
`

export const SidebarMenu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;
  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 60px);
  }
`

export const SidebarLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  text-transform: uppercase;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: #333;
  cursor: pointer;
  &:hover {
    color: #b33f40;
    transition: 0.2s ease-in-out;
  }
`

export const SideButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const SidebarRoute = styled(Link)`
  border-radius: 50px;
  background: #00649f;
  white-space: nowrap;
  padding: 16px 64px;
  color: #fafafa;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  outline: none;
  border: none;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`
